import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import Header from "src/Component/content-component/Header";
import Card from "src/Component/card-components/Card";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import ManavRachnaUniversity from "./IndianUniversities/universities/ManavRachanaPage/ManavRachnaUniversity";
import GalgotiasUniversity from "./IndianUniversities/universities/GalgotiasPage/GalgotiasUniversity";
import JISUniversity from "./IndianUniversities/universities/JISPage/JISUniversity";
import GdGoenkaUniversity from "./IndianUniversities/universities/GdGoenkaPage/GdGoenkaUniversity";
import ImiKolkata from "./IndianUniversities/universities/ImiKolkataPage/Imikolkata";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const university1 = imageBaseUrl + "International-Relation/University/MRU.png";
const university2 =
  imageBaseUrl + "International-Relation/University/galgotias_university.webp";
const university3 =
  imageBaseUrl + "International-Relation/University/jis_university.png";
const university4 =
  imageBaseUrl + "International-Relation/University/GD_Goenka.png";
const university5 =
  imageBaseUrl + "International-Relation/University/IMI_Kolkata.png";

const Universities = [
  {
    title: "Manav Rachna University",
    id: "manav-rachna-university",
    Image: university1,
  },
  {
    title: "Galgotias University",
    id: "galgotias-univeristy",
    Image: university2,
  },
  {
    title: "JIS University",
    id: "jis-univeristy",
    Image: university3,
  },
  {
    title: "GD Goenka University",
    id: "gd-goenka-univeristy",
    Image: university4,
  },
  {
    title: "IMI, Kolkata",
    id: "imi-kolkata",
    Image: university5,
  },
];

const IndianUniversities = () => {
  const [showScroll, setShowScroll] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 1800) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 1800, behavior: "smooth" });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 50; // Adjust scroll position 80px above the section
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box sx={{ textAlign: "center", mt: 4, mb: 6, px: { xs: 2, md: 10 } }}>
      <Header
        content="Indian Universities we are associated with"
        textAlign="center"
        sx={{ mb: 4 }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 3,
        }}
      >
        {Universities.map((item, index) => (
          <Box key={index} sx={{ my: 2 }}>
            <button
              onClick={() => scrollToSection(item.id)}
              style={{
                textDecoration: "none",
                cursor: "pointer",
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
                color: "inherit",
              }}
            >
              <Card
                data={item}
                borderRadius="8px"
                cardHeight="250px"
                cardWidth="200px"
                initialheight="30%"
                width="160px"
                height="130px"
                hoverHeight="30%"
              >
                <img
                  src={item.Image}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "5px",
                  }}
                />
              </Card>
            </button>
          </Box>
        ))}
      </Box>

      <Box sx={{ pt: 5 }}>
        <Box id="manav-rachna-university" sx={{mt:5}} >
          <ManavRachnaUniversity />
        </Box>
        <Box id="galgotias-univeristy" sx={{mt:5}} >
          <GalgotiasUniversity />
        </Box>
        <Box id="jis-univeristy" sx={{mt:5}} >
          <JISUniversity />
        </Box>
        <Box id="gd-goenka-univeristy" sx={{mt:5}} >
          <GdGoenkaUniversity />
        </Box>
        <Box id="imi-kolkata" sx={{mt:5}} >
          <ImiKolkata />
        </Box>
      </Box>

      {showScroll && (
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 20,
            left: 20,
            backgroundColor: "#00999E",
            color: "#fff",
            width: 50,
            height: 50,
            "&:hover": {
              backgroundColor: "#02999E",
            },
          }}
        >
          <FileUploadRoundedIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default IndianUniversities;
